import axios, { AxiosResponse } from 'axios';

const proxyApiUrl = '/services/isnaportal/api';
const proxyOpenApiUrl = '/services/isnaportal/open-api';

const formDataHeaders = {
    headers: { 'Content-Type': 'multipart/form-data' },
};

export const getFalseDeals = (params: any): Promise<AxiosResponse> => {
    return axios.get(`${proxyOpenApiUrl}/false-deal`, { params });
};

export const createFalseDeal = (formData: any): Promise<AxiosResponse> => {
    return axios.post(`${proxyApiUrl}/false-deal`, formData, {
        ...formDataHeaders,
    });
};

export const updateFalseDeal = (id: number, formData: any): Promise<AxiosResponse> => {
    return axios.put(`${proxyApiUrl}/false-deal/${id}`, formData, {
        ...formDataHeaders,
    });
};

export const deleteFalseDeal = (id: number, formData: FormData) => {
    return axios.delete(`${proxyApiUrl}/false-deal/${id}`, {
        data: formData,
        ...formDataHeaders,
    });
};

export const downloadAttachment = (id: number) => {
    const url = `${proxyOpenApiUrl}/false-deal/file`;
    return axios.get(url, { params: { id }, responseType: 'blob' });
};

export const downloadTableFile = (params: any) => {
    return axios.get(`${proxyOpenApiUrl}/false-deal/export`, {
        params,
        responseType: 'blob',
    });
};
